import { FC, ReactNode, useRef, useEffect } from 'react';
import { Upload } from 'antd';
import type { RcFile } from 'antd/es/upload/interface';
import Button from '../Button';

interface IUploadCropImg {
  button?: ReactNode;
  maxCount?: number;
  imagesAccepts?: string;
  imagesNotAccepts?: string[];
  onChange: (file: any) => void;
  onCancel?: () => void;
}

const UploadImg: FC<IUploadCropImg> = ({
  button,
  maxCount,
  imagesAccepts,
  onChange,
  onCancel,
}) => {
  const ref = useRef<any>(null);
  const isSelectingFile = useRef(false);

  useEffect(() => {
    const uploadElement = ref.current?.upload?.uploader;
    if (!uploadElement) return;

    const inputElement = uploadElement.fileInput;
    
    const handleClick = () => {
      isSelectingFile.current = true;
    };

    const handleWindowFocus = () => {
      setTimeout(() => {
        if (isSelectingFile.current) {
          console.log('Usuário cancelou a seleção de arquivo');
          isSelectingFile.current = false;
          if (onCancel) onCancel();
        }
      }, 200);
    };

    if (inputElement) {
      inputElement.addEventListener('click', handleClick);
      window.addEventListener('focus', handleWindowFocus);
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('click', handleClick);
        window.removeEventListener('focus', handleWindowFocus);
      }
    };
  }, []);

  const handleBeforeUpload = (file: RcFile) => {
    isSelectingFile.current = false;
    
    if (maxCount === 1) {
      onChange(file);
    } else {
      onChange([file]);
    }

    return false;
  };

  return (
    <Upload
      ref={ref}
      action={undefined}
      multiple={maxCount !== 1 ? true : false}
      maxCount={maxCount}
      itemRender={() => false}
      accept={imagesAccepts}
      beforeUpload={(handleBeforeUpload)}
    >
      {button ? button : (
        <Button type="text">
          Escolher um arquivo
        </Button>
      )}
    </Upload>
  );
};

export default UploadImg;
